import React, { Component } from 'react';
import { Modal, Radio, Checkbox, DatePicker, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from "moment";
import '../style.less';

const RadioGroup = Radio.Group;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

class ExportModal extends Component {
    state = {
        visible: false,
        ifHospitalChecked: false,
        ifProjectDetailChecked: false,
        ifHospitalCrcInfoChecked: false,
        ifWorkFlowChecked: false,
        ifEthicallyTimeChecked: false,
        ifCasesInHospitalsChecked: false,
        ifStartupOfHospitalsChecked: false,
        searchParams: {},
        chooseExportType: [],
        Hospitalvalue: "",
        ProjectDetailvalue: "",
        HospitalCrcInfovalue: "",
        WorkFlowvalue: "",
        EthicallyTimevalue: "",
        CasesInHospitalsvalue: "",
        StartupOfHospitalsvalue: "",
        beginTime: moment().format(monthFormat),
        endTime: moment().format(monthFormat),
        filterAndRandomStart: moment().format(dateFormat),
        filterAndRandomEnd: moment().format(dateFormat),
        hospitalBeginTime: moment().format(dateFormat),
        hospitalEndTime: moment().format(dateFormat),
    }

    show = (value = {}) => {
        const { ids = {}, areaParams } = value;
        const { arry = [] } = this.props;
        const params = { ...value, ...areaParams, areaParams: undefined, hasCheckedArea: undefined };
        if ((ids.length < arry.length) || (arry.length == 0)) {
            Object.keys(ids).forEach(item => {
                params[`ids[${item}]`] = ids[item];
            });
            delete params.ids;
        } else {
            arry.map((item, index) => {
                params[`ids[${index}]`] = item;
            });
            delete params.ids;
        }

        this.setState({
            flag: "hospitalInfoByNameForSmo",
            searchParams: {
                ...params,
            },
            visible: true,
        });
    }

    handleOk = () => {
        const { Hospitalvalue, ProjectDetailvalue, HospitalCrcInfovalue, WorkFlowvalue, EthicallyTimevalue,
            ifHospitalChecked, ifProjectDetailChecked, ifHospitalCrcInfoChecked, ifWorkFlowChecked, ifEthicallyTimeChecked,
            ifCasesInHospitalsChecked, CasesInHospitalsvalue, StartupOfHospitalsvalue, ifStartupOfHospitalsChecked, searchParams, flag,
        } = this.state;
        const { beginTime, endTime, filterAndRandomStart, filterAndRandomEnd, hospitalBeginTime, hospitalEndTime } = this.state;
        if ((!WorkFlowvalue) && (!Hospitalvalue) && (!ProjectDetailvalue) && (!HospitalCrcInfovalue) && (!EthicallyTimevalue) && (!CasesInHospitalsvalue) && (!StartupOfHospitalsvalue)) {
            message.warning("请选择需要导出的内容")
            return;
        }
        const exportArr = [ 
            WorkFlowvalue,
            Hospitalvalue,
            HospitalCrcInfovalue,
            EthicallyTimevalue, 
            CasesInHospitalsvalue, 
            StartupOfHospitalsvalue,
        ];
        if (ifProjectDetailChecked) {
            exportArr.push(flag);
        }
        let sendParams = {};
        if (EthicallyTimevalue && (ifEthicallyTimeChecked == true)) {
            sendParams.beginTime = beginTime;
            sendParams.endTime = endTime;
        }
        if (CasesInHospitalsvalue && (ifCasesInHospitalsChecked == true)) {
            sendParams.filterAndRandomStart = filterAndRandomStart;
            sendParams.filterAndRandomEnd = filterAndRandomEnd;
        }
        if (StartupOfHospitalsvalue && (ifStartupOfHospitalsChecked == true)) {
            sendParams.hospitalBeginTime = hospitalBeginTime;
            sendParams.hospitalEndTime = hospitalEndTime;
        }
        // if (WorkFlowvalue && (ifWorkFlowChecked == true)) {
        //     const options = {
        //         method: 'POST',
        //         url: `${API_URL.common.startAsynchronousExport}`,
        //         data: { type: 'PROCEDURES' },
        //         dataType: 'json',
        //         doneResult: (res) => {
        //             const { success, asynchronousExportId } = res;
        //             message.success(success);
        //             this.export(asynchronousExportId);
        //         },
        //         errorResult: (() => {
        //             this.setState({ loading: false });
        //         })
        //     };
        //     $.sendRequest(options);
        // }
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.requestExportHospitalListByInves}`,
            data: { 
                exportType: exportArr.filter(el => el).join(';'), 
                ...sendParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: false });
                this.handleCancel();
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        $.sendRequest(options);
        
    }

    export = asynchronousExportId => {
        const {
            searchParams,
            WorkFlowvalue,
        } = this.state;
        searchParams.exportType = WorkFlowvalue;
        searchParams.asynchronousExportId = asynchronousExportId;
        let sendParams = searchParams || {};
        sendParams.beginTime = null;
        sendParams.endTime = null;
        sendParams.filterAndRandomStart = null;
        sendParams.filterAndRandomEnd = null;
        sendParams.hospitalBeginTime = null;
        sendParams.hospitalEndTime = null;
        sendParams.exportType = "ssuHospitalInfo";
        ExportUtil.export(
            sendParams, null, API_URL.hospital.exportHospitalListByInves);
        this.handleCancel();
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            ifHospitalChecked: false,
            ifProjectDetailChecked: false,
            ifHospitalCrcInfoChecked: false,
            ifWorkFlowChecked: false,
            ifEthicallyTimeChecked: false,
            ifCasesInHospitalsChecked: false,
            ifStartupOfHospitalsChecked: false,
            Hospitalvalue: "",
            ProjectDetailvalue: "",
            HospitalCrcInfovalue: "",
            WorkFlowvalue: "",
            EthicallyTimevalue: "",
            CasesInHospitalsvalue: "",
            StartupOfHospitalsvalue: "",
            beginTime: moment().format(monthFormat),
            endTime: moment().format(monthFormat),
            filterAndRandomStart: moment().format(dateFormat),
            filterAndRandomEnd: moment().format(dateFormat),
            hospitalBeginTime: moment().format(dateFormat),
            hospitalEndTime: moment().format(dateFormat),
        });
    }

    onChangeHospitalCheck = (e) => {
        this.setState({ ifHospitalChecked: e.target.checked });

        if (e.target.checked == false) {
            this.setState({ Hospitalvalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({ Hospitalvalue: e.target.value });
        }
    }

    onChangeProjectDetailCheck = (e) => {
        this.setState({ ifProjectDetailChecked: e.target.checked });

        if (e.target.checked == false) {
            this.setState({ ProjectDetailvalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({ ProjectDetailvalue: e.target.value });
        }
    }

    onChangehospitalCrcCheck = (e) => {
        this.setState({ ifHospitalCrcInfoChecked: e.target.checked });

        if (e.target.checked == false) {
            this.setState({ HospitalCrcInfovalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({ HospitalCrcInfovalue: e.target.value });
        }
    }

    onChangeWorkFlowCheck = (e) => {
        this.setState({ ifWorkFlowChecked: e.target.checked });

        if (e.target.checked == false) {
            this.setState({ WorkFlowvalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({ WorkFlowvalue: e.target.value });
        }
    }

    onChangeEthicallyTimeCheck = (e) => {
        this.setState({ ifEthicallyTimeChecked: e.target.checked });
        if (e.target.checked == false) {
            this.setState({ EthicallyTimevalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({
                EthicallyTimevalue: e.target.value,
            });
        }
    }

    handleRadioChange = (e, field) => {
        this.setState({ [field]: e.target.value });
    }

    handleDateChange = (date, dateString, field) => {
        this.setState({ [field]: dateString });
    }

    onChangeCasesInHospitals = (e) => {
        this.setState({ ifCasesInHospitalsChecked: e.target.checked });
        if (e.target.checked == false) {
            this.setState({ CasesInHospitalsvalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({
                CasesInHospitalsvalue: e.target.value,
            });
        }
    }

    onChangeStartupOfHospitals = (e) => {
        this.setState({ ifStartupOfHospitalsChecked: e.target.checked });
        if (e.target.checked == false) {
            this.setState({ StartupOfHospitalsvalue: "" });
        }
        if (e.target.checked == true) {
            this.setState({
                StartupOfHospitalsvalue: e.target.value,
            });
        }
    }

    render() {
        const {
            flag,
            visible,
            ifHospitalChecked,
            ifProjectDetailChecked,
            ifHospitalCrcInfoChecked,
            ifWorkFlowChecked,
            ifEthicallyTimeChecked,
            ifCasesInHospitalsChecked,
            ifStartupOfHospitalsChecked
        } = this.state;
        const { beginTime, endTime, filterAndRandomStart, filterAndRandomEnd, hospitalBeginTime, hospitalEndTime } = this.state;
        const showScreenEndTime = filterAndRandomEnd != '' ? moment(filterAndRandomEnd) : null;
        const showScreenBeginTime = filterAndRandomStart != '' ? moment(filterAndRandomStart) : null;
        const showStartupBeginTime = hospitalBeginTime != '' ? moment(hospitalBeginTime) : null;
        const showStartupEndTime = hospitalEndTime != '' ? moment(hospitalEndTime) : null;
        const radioStyle = {
            display: 'block',
            height: '24px',
            lineHeight: '24px',
        };
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{ marginLeft: -24 }}>请选择导出内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <div><Checkbox onChange={this.onChangeHospitalCheck} checked={ifHospitalChecked} value="hospitalInfo">医院信息列表</Checkbox></div>
                                <div><Checkbox onChange={this.onChangeProjectDetailCheck} checked={ifProjectDetailChecked} value="projectDetail">项目明细</Checkbox></div>
                                {
                                    ifProjectDetailChecked == true &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }} className="projectDetailExport">
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>项目明细导出方式</span>
                                        <RadioGroup onChange={e => this.handleRadioChange(e, 'flag')} value={flag} style={{ verticalAlign: 'top' }}>
                                            <Radio style={radioStyle} value="hospitalInfoByNameForSmo">按医院分组导出(仅津石)</Radio>
                                            <Radio style={radioStyle} value="hospitalInfoByNameForCompany">按医院分组导出(仅竞争公司)</Radio>
                                            <Radio style={radioStyle} value="hospitalInfoByNameForAll">按医院分组导出(津石和竞争公司)</Radio>
                                            <Radio style={radioStyle} value="hospitalInfoByAreaForSmo">按项目领域分组导出(仅津石)</Radio>
                                            <Radio style={radioStyle} value="hospitalInfoByAreaForCompany">按项目领域分组导出(仅竞争公司)</Radio>
                                            <Radio style={radioStyle} value="hospitalInfoByAreaForAll">按项目领域分组导出(津石和竞争公司)</Radio>
                                        </RadioGroup>
                                    </div>
                                }
                                <div><Checkbox onChange={this.onChangehospitalCrcCheck} checked={ifHospitalCrcInfoChecked} value="hospitalCrcInfo">现任CRC人数（按医院）</Checkbox></div>
                                <div><Checkbox onChange={this.onChangeWorkFlowCheck} checked={ifWorkFlowChecked} value="ssuHospitalInfo">办事流程</Checkbox></div>
                                <div><Checkbox onChange={this.onChangeEthicallyTimeCheck} checked={ifEthicallyTimeChecked} value="ssuHospitalMeetingInfo">伦理上会时间明细</Checkbox></div>
                                {
                                    ifEthicallyTimeChecked == true &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }} >伦理上会时间</span>
                                        <MonthPicker
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            className='w-140-common'
                                            format={monthFormat}
                                            placeholder="请选择"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'beginTime')}
                                            allowClear={false}
                                            defaultValue={moment(beginTime)}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <MonthPicker
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            className='w-140-common'
                                            format={monthFormat}
                                            placeholder="请选择"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endTime')}
                                            allowClear={false}
                                            defaultValue={moment(endTime)}
                                        />
                                    </div>
                                }
                                <div><Checkbox onChange={this.onChangeCasesInHospitals} checked={ifCasesInHospitalsChecked} value="hospitalFilterAndRandomInfo">医院筛选病例数/随机病例数</Checkbox></div>
                                {
                                    ifCasesInHospitalsChecked == true &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }} >筛选/随机统计时间</span>
                                        <DatePicker format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="选择日期"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'filterAndRandomStart')}
                                            value={showScreenBeginTime}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <DatePicker format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="选择日期"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'filterAndRandomEnd')}
                                            value={showScreenEndTime}
                                        />
                                    </div>
                                }
                                <div><Checkbox onChange={this.onChangeStartupOfHospitals} checked={ifStartupOfHospitalsChecked} value="hospitalBeginInfo">医院启动情况</Checkbox></div>
                                {
                                    ifStartupOfHospitalsChecked == true &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }} >启动统计时间</span>
                                        <DatePicker format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="选择日期"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'hospitalBeginTime')}
                                            value={showStartupBeginTime}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <DatePicker format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="选择日期"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'hospitalEndTime')}
                                            value={showStartupEndTime}
                                        />
                                    </div>
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/ExportModal.js